import type { DcrParentHcoInput } from '@/core/graphql/generated/types';

import type { usePicklistValues } from '../../_hooks/usePicklistValues';
import type { mapHcpToFormDefaultsIn } from '../mapHcpToFormDefaultsIn';

import { getNetworkFieldValue } from './getNetworkFieldValue';

type FormDefaults = ReturnType<typeof mapHcpToFormDefaultsIn>;
type AffiliationItem = NonNullable<FormDefaults['parenthcos']>[number];

type Picklists = ReturnType<typeof usePicklistValues>['picklists'];

type Props = {
	affiliations: Partial<AffiliationItem>[];
	relationshipTypeOptions: Picklists['relationshipTypeOptions'];
	relationStatusOptions: Picklists['relationStatusOptions'];
	unavailableFields: string[] | undefined;
};

export const mapAffiliationToNetworkApi = ({
	affiliations,
	relationshipTypeOptions,
	relationStatusOptions,
	unavailableFields
}: Props): DcrParentHcoInput[] => {
	return affiliations?.map(affiliation => {
		const status = affiliation?.hcoStatus;
		const resolvedStatus = relationStatusOptions?.find(
			s => s.name === status || s.id === status
		);

		const typeOfRelationship = affiliation?.typeOfRelationship_VId;
		const resolvedTypeOfRelationship = relationshipTypeOptions?.find(
			rs => rs?.id === typeOfRelationship || rs?.name === typeOfRelationship
		);

		const mapped: DcrParentHcoInput = {
			// Note (Ben): Temporarily removing isPrimaryRelationship_V
			// isPrimaryRelationship_V:
			// 	affiliation?.isPrimaryRelationship_V === true ||
			// 	affiliation?.isPrimaryRelationship_V === false
			// 		? affiliation?.isPrimaryRelationship_V
			// 		: undefined,
			parentHcoStatus_VId: resolvedStatus?.id ?? undefined,
			parentHcoVid_V: getNetworkFieldValue(affiliation?.parentHcoVid),
			typeOfRelationship_VId: resolvedTypeOfRelationship?.id ?? undefined,
			jobTitle_V: getNetworkFieldValue(affiliation?.jobTitle_V),
			vid_V: affiliation?.vid_V ? affiliation.vid_V : undefined
		};

		if (unavailableFields && unavailableFields.length > 0) {
			(Object.keys(mapped) as (keyof DcrParentHcoInput)[]).forEach(key => {
				if (unavailableFields.includes(key)) {
					delete mapped[key];
				}
			});
		}

		return mapped;
	});
};
